<ng-container *ngIf="isDisplayReservation">
  <div class="l-mybooking__title-label">{{ orderId }}</div>
  <div *ngIf="orderStatusLabel" class="l-mybooking__title-status" [innerHTML]="orderStatusLabel | staticMsg"></div>
  <div class="l-mybooking__title-ticket c-passenger-display">
    <span class="c-passenger-display__passenger">{{ travelerNumberPeople }}</span>
  </div>
  <div class="l-mybooking__title-btn" *ngIf="linkedOrders.length > 0">
    <ng-container *ngFor="let linkedOrder of linkedOrders">
      <button
        [attr.aria-label]="'reader.relevancePnr' | staticMsg"
        class="l-mybooking__title-btn-item"
        type="button"
        (click)="refreshData(linkedOrder)"
        id="btn-refresh-data"
      >
        <span class="l-mybooking__title-btn-icon">
          <img
            src="{{ appConstants.IMG.S01_P030_S01_U__LINK }}"
            width="20"
            height="20"
            [alt]="'alt.pnrModalDisplay' | staticMsg"
          />
        </span>
        <span class="l-mybooking__title-btn-label">{{ linkedOrder.orderId }}</span>
      </button>
    </ng-container>
  </div>
</ng-container>
